export class OrganizationKeyTypeEnum {
    static readonly PACKING_KEY_RESET = 1;
}